import { Event } from "../domain/events";
import { getActualEventService } from "../infrastructure/services/getActualEventService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getActualEvent = {
  async execute(): Promise<Event | null> {
    return await getActualEventService.execute(await tokenValidation.execute());
  },
};
